import React from 'react';
import { SettingsInlineButton, SettingsSectionBox } from '@views/Settings/components';
import styles from './SystemSettings.module.scss';

export default function SystemSettings() {
  if (!window.desktopIntegrations.openNotificationSettings) {
    return null;
  }

  return (
    <SettingsSectionBox className={styles.container}>
      Clay Notifications
      <SettingsInlineButton onClick={() => window.desktopIntegrations.openNotificationSettings?.()}>
        View System Settings
      </SettingsInlineButton>
      <p>
        Clay notifications can be enabled or disabled in your system settings. If enabled, you can
        control which types of notifications you will receive below.
      </p>
    </SettingsSectionBox>
  );
}
